import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../assets/styles/home.css"
import DaySelector from "./dayselector";
import FilterButton from "./filterbutton";
import MonthSelector from "./monthselector";
import YearSelector from "./yearselector";
import { months } from 'moment';
import uumcLogo from "../assets/images/uumc-logo.jpg";
import { useAuth } from './Auth/AuthContext';
import { API_BASE_URL } from '../config/api';
// import { useQueryTabs } from './queryContext';

const SearchComp = () => {

        const [inputText, setInputText] = useState('')
        //const [finalSearchText, setFinalSearchText] = useState('')
        const [monthSelected, setSelectedMonth] = useState('Month')
        const [daySelected, setSelectedDay] = useState('Day')
        const [yearSelected, setSelectedYear] = useState('Year')
        const [toastText, setToastText] = useState('')
        const [toastVisible, setToastVisible] = useState(false)
        const [filterMode, setFilterMode] = useState('year');
        const navigate = useNavigate();
        const [dashboardMetrics, setDashboardMetrics] = useState({
            totalMembers: null,
            sessionsThisYear: null,
            lastSession: null
        })
        const { token } = useAuth();
        // const { addTab } = useQueryTabs();

        useEffect(() => {
            const getDashboardMetrics = async() => {
                try {
                    const res = await fetch(`${API_BASE_URL}/attendance/attendancedashboard/summary`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    })

                    const data = await res.json();
                    setDashboardMetrics(data);
                } catch(error) {
                    console.error('Error fetching dashboard stats:', error);
                }
            }

            getDashboardMetrics();
        }, [])
    
        const handleInputChange = (event) => {
            setInputText(event.target.value)
        }
    
        const triggerToast = (toastMsg) => {
            setToastText(toastMsg)
            setToastVisible(true)
            setTimeout(() => setToastVisible(false), 4000)
        }
    
        const submissionValidator = () => {
            if(filterMode === "year") {
                if((yearSelected === "Year") && (inputText === '')) {
                    //please enter something(didn't filter by either)
                    triggerToast("Please either search by providing a year or search by member");
                    return false;
                }
                else if((yearSelected === "Year")) {
                    //please select a year to filter as well i.e June 2024
                    triggerToast("Please select a year to filter");
                    return false;
                }
                else if((inputText !== '')) {
                    //can't filter by both. Select either to filter by date or attendee
                    triggerToast("Please search by date or by member name — not both at the same time.");
                    return false;
                } 
                
                return true;
            }
            else if(filterMode === "session") {
                if((monthSelected === "Month" && daySelected === "Day" && yearSelected === "Year") && (inputText === '')) {
                    //please enter something(didn't filter by either)
                    triggerToast("Please either search by providing a date or search by member");
                    return false;
                }
                else if((monthSelected !== "Month" || daySelected !== "Day" || yearSelected !== "Year") && inputText !== '') {
                    triggerToast("Please search by date or by member name — not both at the same time.");
                    return false;
                }
                else if((monthSelected !== "Month" && daySelected === "Day" && yearSelected === "Year")) {
                    //please select a year to filter as well i.e June 2024
                    triggerToast("Please select a day and year to filter by ex: July 25th, 2026");
                    return false;
                }
                else if((monthSelected === "Month" && daySelected !== "Day" && yearSelected === "Year")) {
                    //can't filter just by day. Please select a specific day(7/10/24), year(2024) or month and year(march 2024)
                    triggerToast("Please select a month and year to filter by ex: July 25th, 2026");
                    return false;
                }
                else if((monthSelected === "Month" && daySelected === "Day" && yearSelected !== "Year")) {
                    triggerToast("Please select a month and day to filter by ex: July 25th, 2026");
                    return false;
                }
                else if((monthSelected !== "Month" && daySelected !== "Day" && yearSelected === "Year")) {
                    //please select a year as well. Must be a date(7/10/2024)
                    triggerToast("Please select a year to filter by ex: July 25th, 2026")
                    return false;
                }
                else if((monthSelected !== "Month" && daySelected === "Day" && yearSelected !== "Year")) {
                    //please select a year as well. Must be a date(7/10/2024)
                    triggerToast("Please select a day to filter by ex: July 25th, 2026")
                    return false;
                }
                else if((monthSelected === "Month" && daySelected !== "Day" && yearSelected !== "Year")) {
                    //please select a year as well. Must be a date(7/10/2024)
                    triggerToast("Please select a month to filter by ex: July 25th, 2026")
                    return false;
                }

                return true;
            }

            return false;
        }
    
        const handleSubmitClicked = () => {
            if(submissionValidator()) {
                if(monthSelected !== "Month" && daySelected !== "Day" && yearSelected !== "Year") {
                    const label = `${monthSelected} ${daySelected}, ${yearSelected}`;
                    const state = { month: monthSelected, day: daySelected, year: yearSelected };
                    // addTab({ label, path: '/attendees', state });
                    navigate(`/attendees/${yearSelected}/${monthSelected}/${daySelected}`);
                }
                else if(monthSelected === "Month" && daySelected === "Day" && yearSelected !== "Year") {
                    const label = `Year ${yearSelected}`;
                    const state = { year: yearSelected };
                    // addTab({ label, path: '/filter-by-year', state });
                    navigate(`/filter-by-year/${yearSelected}`);
                }
                    // else if(monthSelected !== "Month" && daySelected === "Day" && yearSelected !== "Year") {
                    //     const label = `${monthSelected} ${yearSelected}`;
                    //     const state = { month: monthSelected, year: yearSelected };
                    //     // addTab({ label, path: '/filter-by-month', state });
                    //     navigate('/filter-by-month', { state });
                    // }
                else {
                    navigate('/filter-by-user', { state: { name: inputText } });
                }
            }
        }
    
        const handleMonthChange = (month) => {
            setSelectedMonth(month);
        };
    
        const handleDayChange = (day) => {
            setSelectedDay(day);
        };
    
        const handleYearChange = (year) => {
            setSelectedYear(year);
        };

      return (
        <div className="container">
            {toastVisible && (
                <div className="uumc-toast">
                    <div className="uumc-toast-icon">!</div>
                    <div className="uumc-toast-body">
                        <div className="uumc-toast-title">Check your selection</div>
                        <div className="uumc-toast-msg">{toastText}</div>
                    </div>
                </div>
            )}

            <div className="uumc-monitor-banner" onClick={() => navigate('/attendance-monitor')}>
                <div className="uumc-monitor-left">
                    <div className="uumc-monitor-top">
                        <div className="uumc-live-pill">
                            <div className="uumc-live-dot"></div>
                            <span className="uumc-live-text">Live</span>
                        </div>
                    </div>
                    <div className="uumc-monitor-title">Attendance monitor</div>
                    <div className="uumc-monitor-sub">Real-time RFID scan feed</div>
                </div>
                <div className="uumc-monitor-right">
                    <div className="uumc-mini-scans">
                        <div className="uumc-mini-scan">
                            <span className="uumc-mini-name">Ryan Gosling</span>
                            <div className="uumc-mini-bars">
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--done"></div>
                            </div>
                        </div>
                        <div className="uumc-mini-scan">
                            <span className="uumc-mini-name">James Tower</span>
                            <div className="uumc-mini-bars">
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--done"></div>
                                <div className="uumc-mbar uumc-mbar--active"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                            </div>
                        </div>
                        <div className="uumc-mini-scan">
                            <span className="uumc-mini-name uumc-mini-name--muted">Waiting...</span>
                            <div className="uumc-mini-bars">
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                                <div className="uumc-mbar uumc-mbar--empty"></div>
                            </div>
                        </div>
                    </div>
                    <div className="uumc-monitor-arrow">→</div>
                </div>
            </div>

            <div className="uumc-stat-grid">
                <div className="uumc-stat-card">
                    <div className="uumc-stat-label">Total members</div>
                    <div className="uumc-stat-value">{dashboardMetrics.totalMembers}</div>
                </div>
                <div className="uumc-stat-card">
                    <div className="uumc-stat-label">Sessions this year</div>
                    <div className="uumc-stat-value">{dashboardMetrics.sessionsThisYear}</div>
                </div>
                <div className="uumc-stat-card">
                    <div className="uumc-stat-label">Last session</div>
                    <div className="uumc-stat-value">{dashboardMetrics.lastSession}</div>
                </div>
                 <div className="uumc-stat-card">
                    <div className="uumc-stat-label">Average Attendance</div>
                    <div className="uumc-stat-value">{dashboardMetrics.avgAttendance}</div>
                </div>
            </div>
            
            <div className="uumc-section-label">Search attendance</div>
            <div className="uumc-search-grid">

                <div className="uumc-search-card" data-testid="search-by-date-card">
                    <div>
                        <div className="uumc-card-title">📅 Search by date</div>
                        <div className="uumc-card-sub">
                            {filterMode === 'year' ? 'Browse all sessions in a year by month' : 'Find attendance for a specific date'}
                        </div>
                    </div>

                    <div className="uumc-pill-bar">
                        <button
                            className={`uumc-pill-tab ${filterMode === 'year' ? 'uumc-pill-tab--active' : ''}`}
                            onClick={() => setFilterMode('year')}
                            data-testid="browse-by-year-tab"
                        >
                            <div className="uumc-tab-icon">📆</div>
                            Browse by year
                        </button>
                        <button
                            className={`uumc-pill-tab ${filterMode === 'session' ? 'uumc-pill-tab--active' : ''}`}
                            onClick={() => setFilterMode('session')}
                            data-testid="specific-session-tab"
                        >
                            <div className="uumc-tab-icon">🔍</div>
                            Specific session
                        </button>
                    </div>

                    {/* year only mode */}
                    {filterMode === 'year' && (
                        <div className="uumc-field">
                            <label>Year</label>
                            <YearSelector onYearChange={handleYearChange}/>
                        </div>
                    )}

                    {/* specific session mode */}
                    {filterMode === 'session' && (
                        <div className="uumc-session-fields">
                            <div className="uumc-field">
                                <label>Year</label>
                                <YearSelector onYearChange={handleYearChange}/>
                            </div>
                            <div className="uumc-date-row">
                                <div className="uumc-field">
                                    <label>Month</label>
                                    <MonthSelector onMonthChange={handleMonthChange}/>
                                </div>
                                <div className="uumc-field">
                                    <label>Day</label>
                                    <DaySelector onDayChange={handleDayChange}/>
                                </div>
                            </div>
                        </div>
                    )}

                    <FilterButton onClick={handleSubmitClicked} testId="session-search-submit"/>
                </div>

                <div className="uumc-search-card" data-testid="search-by-user-card">
                    <div>
                        <div className="uumc-card-title">👤 Search by member</div>
                        <div className="uumc-card-sub">View all sessions a member attended</div>
                    </div>
                    <div className="uumc-divider"></div>
                    <div className="uumc-field">
                        <label>Member name</label>
                        <div className="attendee_input">
                            <input
                                onChange={handleInputChange}
                                type="text"
                                id="fname"
                                name="firstname"
                                placeholder="e.g. Raymond Lin"
                                data-testid="member-search-input"
                            />
                        </div>
                    </div>
                    <FilterButton onClick={handleSubmitClicked} testId="user-search-submit"/>
                </div>

            </div>
        </div>
    );
}

export default SearchComp;


